import React, { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Printer, ChevronRight, CircleX } from "lucide-react";
import { getPayment, updatePayment } from "../api/paymentApi";
import { fetchOrderById } from "../api/orderApi";
import { useTranslation } from "react-i18next";
import Logo from "../components/logo";
import { createShipment } from "../api/aramexApi";

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [paymentData, setPaymentData] = useState(null);
  const [orderData, setOrderData] = useState(null);

  const paymentId = searchParams.get("paymentId");
  const OrderId = searchParams.get("OrderId");
  const isJustView = searchParams.get("isJustView");
  const payment_id = searchParams.get("payment_id");

  //We need to add if isJustView false to update the payment status and after geting payment response
  //else if isJustView is true, it means no need to process getpayment nor update payment, we need just to get order Details from fetchOrderById

  useEffect(() => {
    if (isJustView === "true") {
      // Fetch only order details
      fetchOrderById(OrderId)
        .then((response) => {
          setOrderData(response);
          if (response?.payments.length > 0) {
            const gatewayData = JSON.parse(response?.payments[0]?.gateway_response);
            console.log(gatewayData);
            setPaymentData(gatewayData);
          }
        })
        .catch((error) => {
          console.error(t("err.order.fetch"), error);
        });
    } else {
      getPayment(paymentId, "PaymentId")
        .then((response) => {
          if (response.IsSuccess) {
            setPaymentData(response?.Data);
            updatePaymentStatus(response?.Data);
          }
        })
        .catch((error) => {
          console.error("Error in Execute Payment:", error);
        });
    }
  }, [paymentId, OrderId, isJustView]);

  useEffect(() => {
  console.log("OrderId:", OrderId);
  console.log("isJustView:", isJustView);
  console.log("Payment Data:", paymentData);

  if (!OrderId || isJustView === "true") return;

  const paymentStatus =
    paymentData?.InvoiceTransactions?.[0]?.TransactionStatus;

  console.log("Payment Status:", paymentStatus);

  const isSuccess =
    paymentStatus === "Success" ||
    paymentStatus === "Succss" ||
    paymentStatus === "Paid";// ||
    // paymentStatus === "Failed";//just for testing

  console.log("Is Payment Successful?", isSuccess);

  if (isSuccess) {
    createShipment(OrderId);
  }
}, [paymentData, OrderId]);

  //update payment status if isJustView false
  const updatePaymentStatus = useCallback((data) => {
    updatePayment({
      payment_status: data?.InvoiceTransactions[0]?.TransactionStatus,
      transaction_id: paymentId,
      gateway_response: JSON.stringify(data),
      payment_id,
    })
      .then((response) => {
        if (response.IsSuccess) {
          // setPaymentData(response?.Data);
        }
      })
      .catch((error) => {
        console.error("Error in Execute Payment:", error);
      });
  }, []);

  const handlePrint = () => {
    window.print();
  };

  if (isJustView === "true" && !orderData) {
    return (
      <div className="min-h-screen flex items-center justify-center space-x-3">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <div>{t('order.load')}...</div>
      </div>
    );
  }

  if (isJustView !== "true" && !paymentData) {
    return (
      <div className="min-h-screen flex items-center justify-center space-x-3">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <div>{t('payment.load')}...</div>
      </div>
    );
  }

  const transaction = paymentData?.InvoiceTransactions[0];
  const payment_status = paymentData?.InvoiceTransactions[0]?.TransactionStatus || orderData?.payments[0]?.payment_status;

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        
        {/* Ministry Compliant Header - Static Information */}
        <div className="bg-white rounded-lg shadow-sm p-2 mb-2 print:shadow-none">
          <div className="flex justify-between items-start mb-2">
            {/* Logo and Business Info */}
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              <div className="w-16 h-16 bg-blue-300 rounded-lg flex items-center justify-center print:bg-gray-700">
                <Logo />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 mb-1">
 ديلير                 </h1>
                <h2 className="text-xl font-semibold text-gray-700">
                  Delire Prefume
                </h2>
                <p className="text-sm text-gray-600 mt-1">
                  رقم السجل التجاري: 209993 | C.R. No: 209993
                </p>
              </div>
            </div>
            
            {/* Invoice Number and Date */}
            <div className="text-right">
              <div className="bg-gray-50 p-2 rounded-lg print:bg-gray-100">
                <p className="text-sm text-gray-600 mb-1">رقم الفاتورة / Invoice No.</p>
                <p className="text-lg font-bold text-gray-900">INV-{OrderId}</p>
                <p className="text-sm text-gray-600 mt-2">التاريخ / Date</p>
                <p className="text-sm font-medium">
                  {new Date(transaction?.TransactionDate || orderData?.payments[0]?.createdAt || new Date()).toLocaleDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Success Header */}
        {orderData?.payments[0]?.payment_method !== "cash_delivery" && (
          <div className="bg-white rounded-lg shadow-sm p-2 mb-2 text-center print:shadow-none">
            <div className="mx-auto w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-2">
              {payment_status === "Paid" || payment_status === "Succss" || payment_status === "Success" ? (
                <Check className="w-6 h-6 text-green-600" />
              ) : (
                <CircleX className="w-6 h-6 text-red-600" />
              )}
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">
              {payment_status === "Paid" || payment_status === "Succss" || payment_status === "Success"
                ? t("payment.success")
                : t("payment.failed")}!
            </h1>
            <p className="text-gray-600">
              {payment_status === "Paid" || payment_status === "Succss" || payment_status === "Success"
                ? t("payment.success.msg")
                : t("payment.failed.msg")}
            </p>
          </div>
        )}

        {/* Invoice Details */}
        <div className="bg-white rounded-lg shadow-sm p-2 mb-2 print:shadow-none text-sm">
          <div className="flex justify-between items-center mb-2">
            <h2 className="text-xl font-bold text-gray-900">
              {t('InvoiceDetails')} / تفاصيل الفاتورة
            </h2>
            <div className="flex gap-2 print:hidden">
              <button
                onClick={handlePrint}
                className="flex items-center px-4 py-2 text-sm border rounded-lg hover:bg-gray-50"
              >
                <Printer className="w-4 h-4 mr-2" />
                {t('PrintInvoice')} / طباعة الفاتورة
              </button>
            </div>
          </div>

          <div className="space-y-6">
            {/* Customer Information */}
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                {paymentData && (
                  <>
                    <h3 className="text-sm font-medium text-gray-500 mb-2 border-b pb-1">
                      {t("CustomerInformation")} / معلومات العميل
                    </h3>
                    <div className="text-sm space-y-1">
                      <div className="flex justify-between">
                        <span className="text-gray-600">الاسم / Name:</span>
                        <span className="font-medium text-gray-900">{paymentData?.CustomerName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">البريد / Email:</span>
                        <span className="text-gray-600">{paymentData?.CustomerEmail}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">الهاتف / Mobile:</span>
                        <span className="text-gray-600">{paymentData?.CustomerMobile}</span>
                      </div>
                    </div>
                  </>
                )}
                
                {orderData?.Client && (
                  <div className="text-sm space-y-1">
                    <h3 className="text-sm font-medium text-gray-500 mb-2 border-b pb-1">
                      {t('UserInformation')} / معلومات المستخدم
                    </h3>
                    <div className="flex justify-between">
                      <span className="text-gray-600">المعرف / ID:</span>
                      <span className="text-gray-600">{orderData?.Client.client_id}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">{t('name')} / الاسم:</span>
                      <span className="text-gray-600">{orderData?.Client.username}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">{t('email')} / البريد:</span>
                      <span className="text-gray-600">{orderData?.Client.email}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">{t('mobile')} / الهاتف:</span>
                      <span className="text-gray-600">{orderData?.Client.mobile}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">{t('country')} / الدولة:</span>
                      <span className="text-gray-600">{orderData?.Client.country}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">{t('address')} / العنوان:</span>
                      <span className="text-gray-600">{orderData?.Client.address}</span>
                    </div>
                  </div>
                )}
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-500 mb-1 border-b pb-1">
                  {t('PaymentInformation')}
                </h3>
                <div className="text-sm space-y-1">
                  <div className="flex justify-between">
                    <span className="text-gray-600">طريقة الدفع / Method:</span>
                    <span className="text-gray-600">{transaction?.PaymentGateway || orderData?.payments[0]?.payment_method}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">البطاقة / Card:</span>
                    <span className="text-gray-600">{transaction?.CardNumber}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">الدولة / Country:</span>
                    <span className="text-gray-600">{transaction?.Country || orderData?.Branch?.country}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Transaction Details */}
            <div>
              <h3 className="text-sm font-medium text-gray-500 mb-2 border-b pb-1">
                {t('TransactionDetails')}
              </h3>
              <div className="border rounded-lg divide-y">
                <div className="grid grid-cols-2 p-2">
                  <span className="text-gray-600">رقم الطلب / Order ID</span>
                  <span className="font-medium text-right">{OrderId}</span>
                </div>
                <div className="grid grid-cols-2 p-2">
                  <span className="text-gray-600">رقم المعاملة / Transaction ID</span>
                  <span className="font-medium text-right">{transaction?.PaymentId || orderData?.payments[0]?.payment_id}</span>
                </div>
                <div className="grid grid-cols-2 p-2">
                  <span className="text-gray-600">التاريخ / Date</span>
                  <span className="font-medium text-right">
                    {new Date(transaction?.TransactionDate || orderData?.payments[0]?.createdAt).toLocaleString()}
                  </span>
                </div>
                <div className="grid grid-cols-2 p-2">
                  <span className="text-gray-600">الحالة / Status</span>
                  <span className="font-medium text-green-600 text-right">
                    {paymentData?.InvoiceStatus || payment_status}
                  </span>
                </div>
              </div>
            </div>
{orderData?.OrderItems?.length > 0 && (
  <div>
    <h3 className="text-sm font-medium text-gray-500 mb-2 border-b pb-1">تفاصيل الطلب / Order Items</h3>
    <div className="overflow-x-auto rounded-lg border">
      <table className="min-w-full text-sm divide-y divide-gray-200 text-left rtl:text-right">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="px-4 py-2 font-medium">#</th>
            <th className="px-4 py-2 font-medium">اسم المنتج / Product</th>
            <th className="px-4 py-2 font-medium">الكمية / Quantity</th>
            <th className="px-4 py-2 font-medium">سعر الوحدة / Unit Price</th>
            <th className="px-4 py-2 font-medium">الإجمالي / Subtotal</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 text-gray-700">
          {orderData.OrderItems.map((item, index) => (
            <tr key={item.order_item_id}>
              <td className="px-4 py-2">{index + 1}</td>
              <td className="px-4 py-2">
                <div className="font-medium">
                  {item.Product?.name}{" "}
                  <span className="text-xs text-gray-500">({item.Product?.ar_name})</span>
                </div>
              </td>
              <td className="px-4 py-2">{item.quantity}</td>
              <td className="px-4 py-2">{item.unit_price} {orderData?.Branch?.currency}</td>
              <td className="px-4 py-2">{item.subtotal} {orderData?.Branch?.currency}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}
            {/* Payment Summary */}
            <div className="border-t pt-2">
              <h3 className="text-sm font-medium text-gray-500 mb-4">ملخص الدفع / Payment Summary</h3>
              <div className="space-y-1">
                {/* <div className="flex justify-between items-center">
                  <span className="text-gray-600">المجموع الفرعي / Subtotal</span>
                  <span className="font-medium">
                    {transaction?.TransationValue} {transaction?.Currency}
                  </span>
                </div> */}
                <div className="flex justify-between items-center">
                  <span className="text-gray-600"> رسوم التوصيل /Devliery Charges</span>
                  <span className="font-medium">
                    {orderData?.shipping_cost} {orderData?.Branch?.currency}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-600">رسوم الخدمة / Service Charge</span>
                  <span className="font-medium">
                    {transaction?.CustomerServiceCharge} {transaction?.Currency}
                  </span>
                </div>
                <div className="flex justify-between items-center text-lg font-bold pt-3 border-t-2 border-gray-200">
                  <span>الإجمالي / Total</span>
                  <span className="text-blue-600">
                    {paymentData?.InvoiceDisplayValue || orderData?.total_amount} {transaction?.Currency || orderData?.Branch?.currency}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ministry Compliant Footer */}
        <div className="bg-white rounded-lg shadow-sm p-2 mb-2">
          <div className="border-t pt-6">
            <div className="grid md:grid-cols-3 gap-6 text-sm">
              <div>
                <h4 className="font-medium text-gray-900 mb-2">معلومات الاتصال / Contact Information</h4>
                <p className="text-gray-600">Customer Service: +974 77759648</p>
                <p className="text-gray-600">Support: +974 71700047</p>
                <p className="text-gray-600">info@delire.net</p>
                <p className="text-gray-600">delire.net</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-2">العنوان / Address</h4>
                <p className="text-gray-600">قطر الدوحة، مدينة خليفة الجنوبية، شارع الجزيرة العربية مبنى رقم 122، الطابق الثاني
                </p>
                <p className="text-gray-600">
                 Qatar, Doha, Madinat Khalifa South, Al-Jazeera Arabia St. Building No. 122. Second Floor
                </p>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 mb-2">تفاصيل قانونية / Legal Details</h4>
                <p className="text-gray-600">رقم السجل: 209993</p>
                <p className="text-gray-600">License No: 209993</p>
                <p className="text-gray-600">صادر من وزارة التجارة والصناعة</p>
                <p className="text-gray-600">Issued by Ministry of Commerce & Industry</p>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Links */}
        <div className="text-center print:hidden">
          <button className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium">
            {t('ViewOrders')} <ChevronRight className="w-4 h-4 ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;